import React, { useEffect, useRef, useState } from 'react';
import ReactTooltip from 'react-tooltip';
import getElementWidthHoc from '../hoc/getElementWidthHoc';
import { findLastIndex, sum } from 'lodash';
var OTHERS_TAGS_WIDTH = 24;
var ChipsCollection = function (_a) {
    var componentWidth = _a.width, chipRenderer = _a.chipRenderer, items = _a.items;
    var allChipsContainer = useRef(null);
    var _b = useState([]), allChips = _b[0], setAllChips = _b[1];
    var _c = useState([]), visibleChips = _c[0], setVisibleChips = _c[1];
    var _d = useState([]), hiddenChips = _d[0], setHiddenChips = _d[1];
    useEffect(function () {
        setAllChips(items);
        setVisibleChips([]);
        setHiddenChips([]);
        if (!allChipsContainer.current || !componentWidth) {
            return;
        }
        // recalculate the width of all tags when the array of tags changes
        var chipsWidths = Array.from(allChipsContainer.current.children).map(function (chipElement) {
            var _a = getComputedStyle(chipElement), width = _a.width, marginLeft = _a.marginLeft, marginRight = _a.marginRight;
            return parseFloat(width) + parseFloat(marginLeft) + parseFloat(marginRight);
        });
        // find the last chip that fits to the cell
        var lastVisibleChipIndex = findLastIndex(chipsWidths, function (_width, i) {
            // calculate width of current and all previous chips together
            var totalWidth = sum(chipsWidths.slice(0, i + 1));
            // add the width of '+1'
            if (chipsWidths.length - 1 !== i) {
                totalWidth += OTHERS_TAGS_WIDTH;
            }
            return totalWidth < componentWidth;
        });
        setVisibleChips(items.slice(0, lastVisibleChipIndex + 1));
        setHiddenChips(items.slice(lastVisibleChipIndex + 1));
    }, [allChipsContainer.current, items, componentWidth]);
    var tooltipId = Date.now() + '';
    var renderChip = function (item) {
        // the index passed to chipRenderer needs to be the index of item in original array, not the index of visibleChips/hiddenChips
        var index = allChips.indexOf(item);
        return chipRenderer(item, index);
    };
    return (React.createElement("div", { className: "chipsCollection__container" },
        React.createElement("span", { className: "chipsCollection__allChips", ref: allChipsContainer }, allChips.map(renderChip)),
        visibleChips.length > 0 && React.createElement("span", { className: 'chipsCollection__visibleTags' }, visibleChips.map(renderChip)),
        hiddenChips.length > 0 && React.createElement(React.Fragment, null,
            React.createElement("span", { className: 'chipsCollection__hiddenChipsCount', "data-tip": true, "data-for": tooltipId },
                "+",
                hiddenChips.length),
            React.createElement(ReactTooltip, { place: "bottom", className: 'accurity-tooltip chipsCollection__tooltip', html: false, type: "light", id: tooltipId, delayHide: 300, effect: 'solid', border: true, borderColor: '#e0e0e0' }, hiddenChips.map(renderChip)))));
};
export default getElementWidthHoc(ChipsCollection, { className: 'chipsCollection' });
//# sourceMappingURL=ChipsCollection.js.map